<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" v-if="active">
    <path fill-rule="evenodd" fill="#413887" d="M40.999 45.999h-4v-36h4a5 5 0 0 1 5 5v26a5 5 0 0 1-5 5zm-29-42a4 4 0 0 1 4-3.999h14c2.21 0 4 1.79 4 3.999v42h-22v-42zm3 6h16v-5a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v5zm-10 36a4.999 4.999 0 0 1-4.999-5v-26a5 5 0 0 1 4.999-5h4v36h-4z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" v-else>
    <path fill-rule="evenodd" fill="#333" d="M40.999 45.999h-4v-36h4a5 5 0 0 1 5 5v26a5 5 0 0 1-5 5zm2-29c0-2.761-.238-4-2.999-4v30c2.761 0 2.999-1.238 2.999-4v-22zm-31-13a4 4 0 0 1 4-3.999h14c2.21 0 4 1.79 4 3.999v42h-22v-42zm3 39h16v-30h-16v30zm0-33h16v-5a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v5zm-10 36a4.999 4.999 0 0 1-4.999-5v-26a5 5 0 0 1 4.999-5h4v36h-4zm1-33c-2.761 0-3 1.239-3 4v22c0 2.762.239 4 3 4v-30z"/>
  </svg>
</template>
<script>
export default {
  props:{
    active:Boolean
  },
}
</script>